// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__+iFh6","imagem":"Banner_imagem__-uIKH","titulo":"Banner_titulo__3sB3T","titulo1":"Banner_titulo1__B5OnY"};